import {
  FontAwesomeIcon,
  FontAwesomeIconProps
} from '@fortawesome/react-fontawesome'

export type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

export interface IconProps extends Omit<FontAwesomeIconProps, 'size'> {
  /** Height in pixels, or any CSS length. Defaults to the surrounding font size. */
  size?: number | string
}

/**
 * Draws a Font Awesome Free icon, the app's only icon set (DEV-376):
 * `<Icon icon={faTrashCan} size={14} />`. Import the definition from
 * `@fortawesome/free-solid-svg-icons` or `@fortawesome/free-regular-svg-icons`.
 */
export function Icon({ size, style, ...props }: IconProps) {
  return (
    <FontAwesomeIcon
      {...props}
      style={size === undefined ? style : { fontSize: size, ...style }}
    />
  )
}
